export const GET_ALL_PRODUCTS = 'GET_ALL_PRODUCTS';
export const GET_PRODUCT_DETAIL = 'GET_PRODUCT_DETAIL';
export const ADD_CART = 'ADD_CART';
export const FILTER_BY_PRICE = 'FILTER_BY_PRICE';
export const RESET_CART = 'RESET_CART';
export const SEARCH_PRODUCTS = 'SEARCH_PRODUCTS';
// export const GET_PROFILE = 'GET_PROFILE';
export const EDIT_PROFILE = 'EDIT_PROFILE';
export const GET_CATEGORIES = 'GET_CATEGORIES';
export const SET_FILTER = 'SET_FILTER';
export const FILTER_CATEGORIES = 'FILTER_CATEGORIES';
export const GET_BRANDS = 'GET_BRANDS';
export const FILTER_BRANDS = 'FILTER_BRANDS';
export const FILTER_MIN = 'FILTER_MIN_MAX';
export const FILTER_MAX = 'FILTER_MAX';
export const SET_FILTER_MAX = 'SET_FILTER_MAX';
export const CLEAN = 'CLEAN';
export const CREATE_PRODUCT = 'CREATE_PRODUCT';
export const GET_USER_DATA = 'GET_USER_DATA';
export const SET_FILTER_PRICE = 'SET_FILTER_PRICE';
export const CLEAN_FILTER = 'CLEAN_FILTER';
export const BUILD_PC = 'BUILD_PC';
export const GET_PRODUCTS_BY_CATEGORY = 'GET_PRODUCTS_BY_CATEGORY';
export const EDIT_PRODUCT = 'EDIT_PRODUCT';
export const DELETE_PRODUCT = 'DELETE_PRODUCT';
export const SET_FILTER_BRANDS = 'SET_FILTER_BRANDS';
export const CLEAN_FILTER_BRANDS = 'CLEAN_FILTER_BRANDS';
export const ADD_FAV = 'ADD_FAV';
export const DELETE_FAV = 'DELETE_FAV';
/// FILTRADO
export const FILTER_CATEGORY = 'FILTER_CATEGORY';
export const FILTER_BRAND = 'FILTER_BRAND';
export const NEXT_PAGE = 'NEXT_PAGE';
export const PREV_PAGE ='PREV_PAGE';
export const SET_PAGE = 'SET_PAGE';
export const CLEAN_PRODUCTS = 'CLEAN_PRODUCTS'
// GETS ///
export const GET_GPUS = 'GET_GPUS';
export const SET_ORDER = 'SET_ORDER';
export const CLEAN_ORDER = 'CLEAN_ORDER';
export const CLEAN_FILTER_PRICE = 'CLEAN_FILTER_PRICE';
export const FILTER_PRICE = 'FILTER_PRICE';
export const GET_COMMEND_PENDING = 'GET_COMMEND_PENDING';
export const GET_COMMEND_PRODUCT = 'GET_COMMEND_PRODUCT';
export const GET_FAV = 'GET_FAV';
// QUESTION //
export const SEND_RESPONSE = 'SEND_RESPONSE'
export const GET_QUESTION = 'GET_QUESTION'
export const GET_QUEST = 'GET_QUEST'
export const POST_QUESTION = 'POST_QUESTION'
// PAGINADO PRODUCTS //
export const NEXT_PAGE_PRODUCTS = 'NEXT_PAGE_PRODUCTS';
export const PREV_PAGE_PRODUCTS ='PREV_PAGE_PRODUCTS';
export const SET_PAGE_PRODUCTS = 'SET_PAGE_PRODUCTS';
// LISTA DE COMPRA
export const GET_HISTORY = 'GET_HISTORY'